import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import useStyles from './Header.styles';

const Header = ({ header, onClick }) => {
  const classes = useStyles();

  const { current: cellStyle } = useRef({ width: `${header.columnWidth}rem` });

  return (
    <TableCell classes={classes} style={header.columnWidth ? cellStyle : undefined}>
      {header.unsortable && header.render('Header')}
      {!header.unsortable && (
        <TableSortLabel active={header.isSorted} direction={header.isSortedDesc ? 'desc' : 'asc'} onClick={onClick}>
          {header.render('Header')}
        </TableSortLabel>
      )}
    </TableCell>
  );
};

Header.propTypes = {
  header: PropTypes.shape().isRequired,
  onClick: PropTypes.func,
};

Header.defaultProps = {
  onClick: undefined,
};

export default Header;
